export default {
  hint: 'Confirmă plata cu banca ta pentru a finaliza comanda.',
  cancel: 'Anulează plata',
};
